import { MessageConversationSubscription, MessageConversationTypeEnum } from '@/types/generated/graphql';
import { CALL_STATUS } from '@shared/constants';
import { useSwitchCallStore as switchCallStore } from '@shared/layouts/app-layout/components/app-banner/banners/store/use-switch-call.store';

export function switchCallHandler(data: MessageConversationSubscription) {
  const callId = data?.messageConversation?.id;
  const conversationStatus = data?.messageConversation?.conversationStatus;
  const conversationType = data?.messageConversation?.conversationType;
  const isConference = conversationType === MessageConversationTypeEnum.conference;
  const agent = data?.messageConversation?.agent;

  if (isConference && conversationStatus == CALL_STATUS.IN_PROGRESS) {
    switchCallStore.setState({ showSwitchCall: true, agent, callId });
  }

  if (isConference && conversationStatus == CALL_STATUS.COMPLETED) {
    switchCallStore.setState({ showSwitchCall: false, agent: null, callId: null });
  }
}
